import styled from 'styled-components';

export const TextLink = styled.a`
  text-decoration: underline;
  color: ${props => props.theme.colors.gray100};

  &:hover {
    cursor: pointer;
    color: ${props => props.theme.colors.action.hover};
  }

  &:focus {
    color: ${props => props.theme.colors.action.hover};
  }
`;

export const PageWrapper = styled.div`
  padding: 24px 24px 0;

  @media (max-width: 639px) {
    padding: 24px 16px 0;
  }
`;
